import React from "react";
import { Root as StyledRoot } from "./Root.styles";

/**
 * Root container for Toast content
 */
export const Root = (props: any) => <StyledRoot {...props} />;
